<template>
  <div class="home">
    <div class="home-header">
      <div class="orange-bar"></div>
      <div class="gray-bar">
        <div class="gray-bar-content">
          <img src="../../assets/nexum_logo.png" alt="Nexum finanzas">
        </div>
      </div>
    </div>
    <b-container>
      <main>
        <nexum-login></nexum-login>
      </main>
    </b-container>
    <div class="footer">
      <div class="container">
        <div><a href="/#/"><span>He olvidado la contraseña</span></a></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Login from './Login.container';

  export default {
    name: 'home',
    components: {
      'nexum-login': Login,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "../../theme/nexum-bootstrap";
  @import "../../../node_modules/bootstrap/scss/bootstrap.scss";
  .home-header{
    .orange-bar{
      z-index:5;
      position: fixed;
      left:0;
      right: 0;
      margin: 0;
      height: 40px;
      padding: 0 16px 0 24px;
      background-image:  linear-gradient(to right , $nexum-orange-light, $nexum-orange-dark);
      color: #ffffff;
      border-bottom: solid 1px $nexum-gray-light;
    }
    .gray-bar{
      max-height: 25vh;
      text-align: center;
      .gray-bar-content{
        padding-top: 5vh;
        height: 25vh;
        background-color: $nexum-gray-light;
        img {
          margin: 5vh 0;
          width: 40vh;
          max-width: 20vh;
        }
      }
      &:after{
        @include nexum-shadow-border('../../assets');
      }
    }
  }
  .footer{
    z-index: 5;
    background-color: $headers-blue;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    div {
      padding-top: 10px;
      padding-bottom: 5vh;
      @include media-breakpoint-down(sm) {
        padding-bottom: 1vh;
      }
      a {
        color: white;
      }
    }
  }
  main {
    text-align: center;
    @include media-breakpoint-down(sm) {
      margin-bottom: 12vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/features/login/Login.page.vue